
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";
import { CSSSelector } from "@/types/selectors";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";

// @ts-ignore
import draggable from "vuedraggable";
import { openUiPanel } from "@/lib/panels/panels";
import RepeaterItemAccordion from "@/components/Reusable/CustomInputs/Repeater/RepeaterItemAccordion.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    RepeaterItemAccordion,
    draggable,
    TextInput,
    Icon
  }
})
export default class SelectorsList extends Vue {
  @Prop()
  searchable: boolean | undefined;

  @Prop()
  selectors!: CSSSelector[];

  dragOptions = {
    animation: 200,
    handle: ".breakdance-repeater-item-handler",
    filter: ".breakdance-repeater-item--ignore-drag",
    ghostClass: "breakdance-repeater-item--ghost",
    forceFallback: true
  };

  get filteredSelectors() {
    if (this.searchString) {
      return this.selectors.filter(
        selector =>
          this.searchString && selector.name.includes(this.searchString)
      );
    }

    return this.selectors;
  }
  searchString: string | null = "";

  deleteSelector(i: number) {
    const newSelectors = defensiveCopy(this.selectors);
    newSelectors.splice(i, 1);
    this.$emit("input", newSelectors);
  }

  handleDrag(newSelectors: CSSSelector[]) {
    this.$emit("input", defensiveCopy(newSelectors));
  }

  editSelector(name: string) {
    uiStore.setActiveSelectorName(name);
    openUiPanel("selectors");
  }
}
